import React, { createContext, useContext, useEffect } from "react";
import { registerWorksheetListeners, unregisterWorksheetListeners } from "../../excel/workbook/listeners";

interface WorksheetListenerContextType {
  registerListeners: (onUpdate: () => Promise<void>) => Promise<void>;
  unregisterListeners: () => Promise<void>;
}

const WorksheetListenerContext = createContext<WorksheetListenerContextType | undefined>(undefined);

export const WorksheetListenerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    return () => {
      void unregisterWorksheetListeners();
    };
  }, []);

  return (
    <WorksheetListenerContext.Provider
      value={{
        registerListeners: registerWorksheetListeners,
        unregisterListeners: unregisterWorksheetListeners,
      }}
    >
      {children}
    </WorksheetListenerContext.Provider>
  );
};

export const useWorksheetListeners = () => {
  const context = useContext(WorksheetListenerContext);
  if (!context) {
    throw new Error("useWorksheetListeners must be used within WorksheetListenerProvider");
  }
  return context;
};
